import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import useUser from 'shared/hooks/use-user'
import { SharingStatusEnum } from 'modules/share/enum/sharing-status-enum'
import { SharingStatusInterface } from '../types/sharing-status-interface'
import { getSharingStatusPath } from '../api'

export const useSharingStatusPolling = ({ sharingId }: { sharingId?: string }) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, SharingStatusInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: sharingStatus, mutate } = useControlledSwr(
    () => {
      if (!user) return
      if (!sharingId) return
      return getSharingStatusPath(sharingId)
    },
    fetcher,
    {
      refreshInterval(latestData) {
        if (latestData?.status === SharingStatusEnum.Running) {
          return 1500
        }
        return 0
      },
      errorRetryCount: 3,
    },
    !!sharingId,
  )

  return {
    sharingStatus,
    mutate,
  }
}
